import {
  BILLS_GET_BEGIN,
  BILLS_GET_SUCCESS,
  BILLS_GET_FAILURE,
  BILL_SET_SUCCESS, BILL_REMOVE_SUCCESS,
} from './billsActions';

const initialState = {
  bill: null,
  bills: null,
  loading: false,
  error: null
};

export default function billsReducer(state = initialState, action) {
  switch(action.type) {
    case BILLS_GET_BEGIN:
      return {
        ...state,
        loading: true,
        error: null
      };
    case BILLS_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        bills: action.payload.bills
      };
    case BILL_SET_SUCCESS:
      return {
        ...state,
        loading: false,
        bill: action.payload.bill
      };
    case BILL_REMOVE_SUCCESS:
      const billIndex = state.bills.findIndex(bill => bill.id === action.payload.bill.id);
      const newBills = state.bills.slice();

      if (billIndex !== -1) {
        newBills.splice(billIndex, 1);
      }
      return {
        ...state,
        bills: newBills
      };
    case BILLS_GET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        bills: null
      };
    default:
      return state;
  }
}